module.exports = __webpack_public_path__ + "img/logo2.b5843b3a.jpg";